export enum UserPrivilege {
	NON_ADMIN = 'nonAdmin',
	PRODUCT_ADMIN = 'productAdmin',
	SITE_ADMIN = 'siteAdmin',
}
